<template>
  <div class="logs">
    <div class="logs__header">
      <div class="logs__headerLeft">
        <div class="logs__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M1.8 9l-.8-4h22l-.8 4h-2.029l.39-2h-17.122l.414 2h-2.053zm18.575-6l.604-2h-17.979l.688 2h16.687zm3.625 8l-2 13h-20l-2-13h24zm-8 4c0-.552-.447-1-1-1h-6c-.553 0-1 .448-1 1s.447 1 1 1h6c.553 0 1-.448 1-1z"/></svg>
        </div>

        <div
          v-if="paginator.total !== 0"
          class="logs__info"
        >
          <p class="logs__info--xs"><span>{{ separateThousands(paginator.from) }}</span>-<span>{{ separateThousands(paginator.to) }}</span> / <span>{{ separateThousands(paginator.total) }}</span></p>
          <p class="logs__info--sm"><span>{{ separateThousands(paginator.from) }}</span> to <span>{{ separateThousands(paginator.to) }}</span> from <span>{{ separateThousands(paginator.total) }}</span> match{{ paginator.total !== 1 ? 'es' : '' }}</p>
          <p class="logs__info--md">Result{{ paginator.total !== 1 ? 's' : '' }} <span>{{ separateThousands(paginator.from) }}</span> to <span>{{ separateThousands(paginator.to) }}</span> from <span>{{ separateThousands(paginator.total) }}</span> match{{ paginator.total !== 1 ? 'es' : '' }}</p>
        </div>

        <div
          v-else
          class="logs__info"
        >
          <p v-if="loading"><span class="logs__info--title">Loading...</span></p>
          <p v-else-if="paginator.total === 0"><span class="logs__info--title">No results</span></p>
        </div>
      </div>

      <div class="logs__headerRight">
        <FormSelect
          :value="filterAction"
          :options="filterActionOptions"
          type="select"
          size="md"
          variant="darklight"
          ref-name="filterAction"
          :placeholder="filterAction.value"
          :prefilled="true"
          :noLabels="true"
          :squared="true"
          :scrollPosition="0"
          iconSize="sm"
          iconColor="light"
          :icon="icon.filterAction"
          :error="errors.filterAction"
          :status="status.filterAction"
          @valueChanged="setFieldValue($event, 'filterAction')"
          @unfocused="validate('filterAction')"
        />

        <FormSelect
          :value="filterType"
          :options="filterTypeOptions"
          type="select"
          size="md"
          variant="darklight"
          ref-name="filterType"
          :placeholder="filterType.value"
          :prefilled="true"
          :noLabels="true"
          :squared="true"
          :scrollPosition="0"
          iconSize="sm"
          iconColor="light"
          :icon="icon.filterType"
          :error="errors.filterType"
          :status="status.filterType"
          @valueChanged="setFieldValue($event, 'filterType')"
          @unfocused="validate('filterType')"
        />
      </div>
    </div>
 
    <UtilityTable
      class="logs__table"
      type="logs"
      :header="[
        { key: 'action', value: 'Action', width: '80px', hiddenThreshold: '960', capitalizeContent: true, lightText: true },
        { key: 'type', value: 'Type', width: '80px', hiddenThreshold: '1200', capitalizeContent: true, lightText: true },
        { key: 'name', value: 'Name', width: '100%' },
        { key: 'created_at', value: 'Timestamp', width: '160px', capitalizeContent: true, alignRight: true, dimmedText: true }
      ]"
      :dataObject="formattedLogs"
      :loading="loading === true ? true : false"
      @clicked="redirectToLog($event)"
    />

    <div class="logs__footer">
      <UtilityPaginator
        class="logs__paginator"
        layout="full"
        position="bottom"
        :currentPage="paginator.current_page"
        :lastPage="paginator.last_page"
        :perPage="paginator.per_page"
        :from="paginator.from"
        :to="paginator.to"
        :total="paginator.total"
        :loading="loading"
        @changed="paginatorChanged"
      />
    </div>
  </div>
</template>

<script>
import FormSelect from '@/components/form/Select.vue'
import UtilityTable from '@/components/utility/Table.vue'
import UtilityPaginator from '@/components/utility/Paginator.vue'
import config from '@/helpers/config'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    FormSelect,
    UtilityTable,
    UtilityPaginator
  },
  data () {
    return {
      currentView: 'logs',
      page: false,
      action: false,
      type: false,
      filterAction: { key: 'all', name: 'Show all actions' },
      filterType: { key: 'all', name: 'Show all types' },
      filterActionOptions: [
        { 'key': 'all', 'name': 'Show all actions' },
        { 'key': 'view', 'name': 'Show views only' },
        { 'key': 'search', 'name': 'Show searches only' },
        { 'key': 'download', 'name': 'Show downloads only' }
      ],
      filterTypeOptions: [
        { 'key': 'all', 'name': 'Show all types' },
        { 'key': 'datasets', 'name': 'Show datasets only' },
        { 'key': 'pdfs', 'name': 'Show reports only' },
        { 'key': 'news', 'name': 'Show news only' }
      ],
      errors: {
        filterAction: false,
        filterType: false
      },
      status: {
        filterAction: false,
        filterType: false
      },
      icon: {
        filterAction: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M24 14v-4h-3.23c-.229-1.003-.624-1.94-1.156-2.785l2.286-2.286-2.83-2.829-2.286 2.286c-.845-.532-1.781-.928-2.784-1.156v-3.23h-4v3.23c-1.003.228-1.94.625-2.785 1.157l-2.286-2.286-2.829 2.828 2.287 2.287c-.533.845-.928 1.781-1.157 2.784h-3.23v4h3.23c.229 1.003.624 1.939 1.156 2.784l-2.286 2.287 2.829 2.829 2.286-2.286c.845.531 1.782.928 2.785 1.156v3.23h4v-3.23c1.003-.228 1.939-.624 2.784-1.156l2.286 2.286 2.828-2.829-2.285-2.286c.532-.845.928-1.782 1.156-2.785h3.231zm-12 2c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"/></svg>',
        filterType: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M24 14v-4h-3.23c-.229-1.003-.624-1.94-1.156-2.785l2.286-2.286-2.83-2.829-2.286 2.286c-.845-.532-1.781-.928-2.784-1.156v-3.23h-4v3.23c-1.003.228-1.94.625-2.785 1.157l-2.286-2.286-2.829 2.828 2.287 2.287c-.533.845-.928 1.781-1.157 2.784h-3.23v4h3.23c.229 1.003.624 1.939 1.156 2.784l-2.286 2.287 2.829 2.829 2.286-2.286c.845.531 1.782.928 2.785 1.156v3.23h4v-3.23c1.003-.228 1.939-.624 2.784-1.156l2.286 2.286 2.828-2.829-2.285-2.286c.532-.845.928-1.782 1.156-2.785h3.231zm-12 2c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"/></svg>'
      },
      loading: true
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    logs () {
      return this.$store.getters['user/getLogs']
    },
    meta () {
      return this.$store.getters['user/getMeta']
    },
    paginator () {
      if (this.meta && this.meta.logs && this.meta.logs.paginator) {
        return this.meta.logs.paginator
      }

      return false
    },
    // TODO: Format logs here (dataObject) - also do the same @ notifications (Table shouldnt be responsible for these!)
    // FIX: Notifications afterwards (use hiddenThreshold/etc to take as much functionality away from there as possible)
    formattedLogs () {
      let formattedLogs = false

      if (this.logs && this.logs.byId) {
        formattedLogs = this.logs

        for (const [key, value] of Object.entries(formattedLogs.byId)) {
          let name = '-'

          if (value.attributes.action === 'search') {
            name = this.generateName(value.attributes.resources)
          } else if (value.attributes.action === 'view') {
            name = value.attributes.resources[0].title
          } else if (value.attributes.action === 'download') {
            if (value.attributes.resources.length === 1) {
              name = value.attributes.resources[0].title
            } else if (value.attributes.resources.length > 1) {
              name = 'Mass excel download (' + value.attributes.resources.length + ' files)'
            }
          }

          formattedLogs.byId[key].attributes.name = name
          //formattedLogs.byId[key].attributes.created_at = this.formatDate(value.attributes.created_at) TODO: Possibly better format here?
        }
      }

      return formattedLogs
    }
  },
  watch: {
    $route (to, from) {
      if (to.query) {
        if (to.query.page) {
          this.page = to.query.page
        } if (to.query.action) {
          this.action = to.query.action
        } if (to.query.type) {
          this.type = to.query.type
        }
      }

      this.fetchLogs()
    }
  },
  methods: {
    async fetchLogs () {
      this.loading = true
      await this.$store.dispatch('user/fetchLogs', this.getQuery())
      this.loading = false
    },
    redirectToLog (url) {
      this.$router.push(url)
    },
    setFieldValue (value, field) {
      if (field === 'filterAction') {
        this.page = 1
        this.action = value.key
      } else if (field === 'filterType') {
        this.page = 1
        this.type = value.key
      }

      this.$router.push('/settings/logs' + this.getQuery())
    },
    paginatorChanged (newPage) {
      this.page = newPage
      this.$router.push('/settings/logs' + this.getQuery())
    },
    getQuery () {
      let queryParts = []

      if (this.page !== false && this.page !== 1) {
        queryParts.push('page=' + this.page)
      } if (this.action !== false && this.action !== 'all') {
        queryParts.push('action=' + this.action)
      } if (this.type !== false && this.type !== 'all') {
        queryParts.push('type=' + this.type)
      }

      let query = '?' + queryParts.join('&')
      return query
    },
    generateName (filters) {
      let baseFilters = config.validFilters
      let parts = []
      let name = '<span class="text--light"><i>Empty search</i></span>'

      if (filters) {
        for (const baseFilter of baseFilters) {
          for (const [groupKey, group] of Object.entries(filters)) {
            if (group.length > 0) {
              for (const [key, filter] of Object.entries(group)) {
                if (filter.id && filter.type === baseFilter && (!filter.attributes.initializing || filter.attributes.initializing === false)) {
                  parts.push('<span class="text--' + filter.type + '">' + this.capitalizeText(filter.attributes.name) + '</span>')
                }
              }
            }
          }
        }

        if (parts.length > 0) {
          if (parts.length > 5) {
            let extra = parts.length - 5
            parts = parts.slice(0, 5)
            name = parts.join(' + ') + ' + ' + extra + ' more'
          } else {
            name = parts.join(' + ')
          }
        }
      }

      return name
    },
    ...helperMethods
  },
  async created () {
    if (this.$route.query) {
      if (this.$route.query.page) {
        this.page = this.$route.query.page
      } if (this.$route.query.action) {
        this.action = this.$route.query.action
      } if (this.$route.query.type) {
        this.type = this.$route.query.type
      }
    }

    await this.fetchLogs()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.logs {
  @include font('content--sm', $white, 0.9);
  background-color: rgba($white, 0.1);
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 2rem auto;
  border: 1px solid $black;

  @media screen and (min-width: $breakpointSm) {
    width: 90%;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--md', $white, 0.9);
    margin: 2rem auto;
  }

  &__header {
    width: 100%;
    display: flex;
    background-color: $bg-2;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    &Left {
      flex: 1;
      display: flex;
      align-items: center;
    }

    &Right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: right;

      div {
        width: 100%;
        min-width: 140px;
        max-width: 260px;
      }
    }
  }

  &__icon {
    width: 18px;
    min-width: 18px;
    max-width: 18px;
    height: 18px;
    margin: 0 0 0 12px;
    fill: $blue;

    @media screen and (min-width: $breakpointLg) {
      width: 20px;
      min-width: 20px;
      max-width: 20px;
      height: 20px;
    }
  }

  &__info {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;

    &--xs {
      display: -webkit-box;

      @media screen and (min-width: $breakpointSm) {
        display: none;
      }
    }

    &--sm {
      display: none;

      @media screen and (min-width: $breakpointSm) {
        display: block;
      }

      @media screen and (min-width: $breakpointMd) {
        display: none;
      }
    }

    &--md {
      display: none;

      @media screen and (min-width: $breakpointMd) {
        display: block;
      }
    }

    &--lowercase {
      text-transform: initial !important;
    }

    &--title {
      text-transform: uppercase;
      letter-spacing: 0.2px;
      margin-right: 4px;
    }

    &--subtitle {
      letter-spacing: 0.2px;
      margin-right: 4px;

      &blue {
        color: $blue !important;
      }

      &pink {
        color: $pink !important;
      }
    }

    p {
      @include font('content--md', $white, 0.5);
      margin: 0 12px;

      @media screen and (min-width: $breakpointLg) {
        @include font('content--lg', $white, 0.5);
        margin: 0 12px;
      }

      span:not(.header__hidden--xs) {
        color: rgba($white, 0.9);
      }
    }
  }

  &__table {
    //margin: 0 auto 2rem auto;
  }

  &__footer {
    background-color: $bg-2;
    border-top: 1px solid rgba($white, 0.1);
    height: 35px;

    @media screen and (min-width: $breakpointLg) {
      height: 39px;
    }
  }

  &__paginator {
    position: relative;
    top: -1px;
  }
}

</style>
